import React from 'react';

const LogoHorz = () => {
  return (
    <svg
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="133"
      height="66"
      viewBox="0 0 184 91"
    >
      <defs>
        <polygon
          id="logo-horz-a"
          points=".597 .253 14.887 .253 14.887 14 .597 14"
        />
        <polygon
          id="logo-horz-c"
          points=".782 .253 15.073 .253 15.073 14 .782 14"
        />
        <polygon
          id="logo-horz-e"
          points=".585 .513 15.064 .513 15.064 13.74 .585 13.74"
        />
        <polygon
          id="logo-horz-g"
          points=".05 .89 54.65 .89 54.65 51.139 .05 51.139"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <path
          fill="#231F20"
          d="M83.6913,85.6221 C83.8333,86.2841 84.4703,87.2281 86.1953,87.2281 C87.2583,87.2281 87.9433,86.8741 87.9433,86.0241 C87.9433,84.8431 86.5733,84.8661 84.1163,84.3001 C82.3213,83.8751 80.5263,83.1191 80.5263,80.5201 C80.5263,77.6851 82.5813,76.3631 85.8883,76.3631 C88.9823,76.3631 90.9663,77.5441 91.6043,79.6701 L88.3443,80.5441 C88.1083,79.7411 87.2813,79.2451 86.0773,79.2451 C85.0383,79.2451 84.3763,79.6231 84.3763,80.3551 C84.3763,81.2291 85.3443,81.3481 87.5183,81.7961 C89.2663,82.1271 91.7693,82.9301 91.7693,85.9531 C91.7693,88.9531 89.3373,90.1101 86.2183,90.1101 C83.7863,90.1101 80.9273,89.4261 80.2903,86.5201 L83.6913,85.6221 Z"
        />
        <g transform="translate(92 76.11)">
          <mask id="logo-horz-b" fill="#fff">
            <use xlinkHref="#logo-horz-a" />
          </mask>
          <path
            fill="#231F20"
            d="M7.7298,10.5751 C9.7608,10.5751 11.0838,9.1811 11.0838,7.1261 C11.0838,5.0711 9.7608,3.6781 7.7298,3.6781 C5.7218,3.6781 4.3988,5.0711 4.3988,7.1261 C4.3988,9.1811 5.7218,10.5751 7.7298,10.5751 M7.7298,0.2531 C11.9108,0.2531 14.8868,3.1111 14.8868,7.1261 C14.8868,11.1411 11.9108,14.0001 7.7298,14.0001 C3.5728,14.0001 0.5968,11.1411 0.5968,7.1261 C0.5968,3.1111 3.5728,0.2531 7.7298,0.2531"
            mask="url(#logo-horz-b)"
          />
        </g>
        <polygon
          fill="#231F20"
          points="108.399 76.623 112.131 76.623 112.131 86.378 117.941 86.378 117.941 89.851 108.399 89.851"
        />
        <path
          fill="#231F20"
          d="M124.9095,86.3779 C127.2245,86.3779 128.5705,85.5519 128.5705,83.2839 C128.5705,81.0399 127.2245,80.0959 124.9565,80.0959 L123.2795,80.0959 L123.2795,86.3779 L124.9095,86.3779 Z M124.9805,76.6229 C129.1845,76.6229 132.3735,79.1039 132.3735,83.2839 C132.3735,87.5119 129.1845,89.8509 124.9565,89.8509 L119.5475,89.8509 L119.5475,76.6229 L124.9805,76.6229 Z"
        />
        <path
          fill="#9C9EA1"
          d="M133.3895 88.1973C133.3895 87.1583 134.0745 86.3543 135.4205 86.3543 136.7435 86.3543 137.4285 87.1583 137.4285 88.1973 137.4285 89.2363 136.7675 90.0633 135.4205 90.0633 134.0745 90.0633 133.3895 89.2363 133.3895 88.1973M151.9789 86.2363C150.8929 88.5273 148.7669 90.1103 145.6489 90.1103 141.3499 90.1103 138.4439 87.2283 138.4439 83.2603 138.4439 79.3153 141.3499 76.3633 145.6249 76.3633 148.6249 76.3633 150.9629 77.8283 151.9789 80.2603L148.4359 81.2053C148.0349 80.7093 147.2079 79.7883 145.6019 79.7883 143.5469 79.7883 142.2479 81.2053 142.2479 83.2363 142.2479 85.3393 143.6179 86.6853 145.6249 86.6853 147.0419 86.6853 147.9169 86.0243 148.3889 85.2923L151.9789 86.2363z"
        />
        <g transform="translate(152 76.11)">
          <mask id="logo-horz-d" fill="#fff">
            <use xlinkHref="#logo-horz-c" />
          </mask>
          <path
            fill="#9C9EA1"
            d="M7.9159,10.5751 C9.9469,10.5751 11.2699,9.1811 11.2699,7.1261 C11.2699,5.0711 9.9469,3.6781 7.9159,3.6781 C5.9079,3.6781 4.5849,5.0711 4.5849,7.1261 C4.5849,9.1811 5.9079,10.5751 7.9159,10.5751 M7.9159,0.2531 C12.0969,0.2531 15.0729,3.1111 15.0729,7.1261 C15.0729,11.1411 12.0969,14.0001 7.9159,14.0001 C3.7589,14.0001 0.7819,11.1411 0.7819,7.1261 C0.7819,3.1111 3.7589,0.2531 7.9159,0.2531"
            mask="url(#logo-horz-d)"
          />
        </g>
        <g transform="translate(168 76.11)">
          <mask id="logo-horz-f" fill="#fff">
            <use xlinkHref="#logo-horz-e" />
          </mask>
          <path
            fill="#9C9EA1"
            d="M11.3085,8.2128 L11.3085,6.0638 L11.2375,6.0638 L8.9705,10.5748 L6.6085,10.5748 L4.2935,5.8268 L4.1985,5.8268 L4.1985,7.9998 L4.1985,13.7398 L0.5845,13.7398 L0.5845,0.5128 L5.1435,0.5128 L6.8915,3.8188 C7.5055,4.9528 7.9545,5.9448 7.9775,5.9448 L8.0725,5.9448 C8.1205,5.9448 8.5925,4.9528 9.2065,3.7958 L10.9075,0.5128 L15.0645,0.5128 L15.0645,13.7398 L11.3085,13.7398 L11.3085,8.2128 Z"
            mask="url(#logo-horz-f)"
          />
        </g>
        <polygon
          fill="#E6E414"
          points="45.28 65.34 40.97 69.66 38.48 67.17 42.8 62.861"
        />
        <polygon fill="#E6E414" points="45.63 88.08 45.63 88.62 45.628 88.35" />
        <polygon
          fill="#F6921E"
          points="45.628 88.35 45.63 88.08 45.63 88.611"
        />
        <g transform="translate(0 .11)">
          <mask id="logo-horz-h" fill="#fff">
            <use xlinkHref="#logo-horz-g" />
          </mask>
          <polygon
            fill="#E6E414"
            points="24.16 51.139 24.16 35.73 .05 35.73 34.89 .889 54.65 20.651"
            mask="url(#logo-horz-h)"
          />
        </g>
        <polygon
          fill="#8BA728"
          points="69.73 35.84 45.63 35.84 45.63 52.381 32.32 52.381 42.8 62.861 38.48 67.17 24.16 52.861 24.16 51.25 54.65 20.761"
        />
        <polygon
          fill="#93B7C8"
          points="69.77 35.881 53.27 52.381 45.63 52.381 45.63 35.84 69.73 35.84"
        />
        <polygon
          fill="#F6921E"
          points="23.36 52.05 16.21 59.2 8.03 51.03 0 42.99 0 35.89 .04 35.85 23.21 35.85 15.18 43.881"
        />
        <polygon fill="#9B6D22" points="8.03 51.03 0 59.05 0 42.99" />
        <polygon
          fill="#93B7C8"
          points="24.16 67.15 24.16 86.469 20.78 89.849 0 89.849 0 59.049 8.03 51.03 16.21 59.2"
        />
        <polygon
          fill="#9B6D22"
          points="24.16 52.86 24.16 67.15 16.21 59.2 23.36 52.049"
        />
        <polygon fill="#E6E414" points="24.16 51.25 24.16 52.86 23.36 52.05" />
        <polygon
          fill="#866624"
          points="38.48 67.17 31.33 74.32 24.16 67.15 24.16 52.86"
        />
        <polygon
          fill="#8C4A24"
          points="45.63 52.381 45.63 60.02 42.8 62.86 32.32 52.381"
        />
        <polygon
          fill="#9A4C21"
          points="53.27 52.381 45.63 60.02 45.63 52.381"
        />
        <polygon
          fill="#D76229"
          points="45.63 60.02 45.63 74.32 40.97 69.66 45.28 65.34 42.8 62.861"
        />
        <polygon
          fill="#F16522"
          points="69.78 52.381 69.78 89.85 57.088 76.89 52.778 81.2 45.63 74.32 45.63 60.02 53.27 52.381"
        />
        <polygon
          fill="#F6921E"
          points="40.97 69.66 33.82 76.81 31.33 74.32 38.48 67.17"
        />
        <polygon
          fill="#D64629"
          points="45.63 74.32 45.63 88.08 45.628 88.349 33.82 76.81 40.97 69.66"
        />
        <polygon
          fill="#EE4623"
          points="52.778 81.2 45.628 88.349 45.631 74.32"
        />
        <polygon
          fill="#F6921E"
          points="61.17 89.85 47.173 89.85 45.628 88.35 52.778 81.201"
        />
        <polygon
          fill="#9A4C21"
          points="33.82 76.811 20.78 89.85 44.128 89.85 45.628 88.35"
        />
        <polygon
          fill="#8BA728"
          points="33.82 76.811 24.16 86.47 24.16 67.151"
        />
        <polygon
          fill="#93B7C8"
          points="45.628 88.35 44.128 89.85 47.173 89.85"
        />
      </g>
    </svg>
  );
};

export default LogoHorz;
